const Mixin = {
  methods: {
    async calcNewLendingBalance() {
      const current = Number(this.balance.current) || 0
      const prevBalance = Number(this.prevBalance) || 0
      const lendingTotal = Number(this.rmCamma(this.lendingTotal)) || 0
      let newBalance = 0

      if (this.model.type === 'rec') {
        if (this.formState === 'add') {
          newBalance = current - lendingTotal
        } else { // edit
          newBalance = current + prevBalance - lendingTotal
        }
      } else if (this.model.type === 'pay') {
        if (this.formState === 'add') {
          newBalance = current + lendingTotal
        } else { // edit
          newBalance = current - prevBalance + lendingTotal
        }
      }

      this.balance.new = newBalance
    },
    valueBlur(item) {
      if (!item || !item.lending_value) return

      const balanceCurrent = Math.abs(Number(this.balance.current) || 0)
      const prevBalance = Math.abs(Number(this.prevBalance) || 0)
      const totalBalance = this.formState === 'add' ? balanceCurrent : balanceCurrent + prevBalance

      const n = Number(item.n) || 1
      const difference = Math.abs(totalBalance - item.lending_value * n)

      if (difference < 0.001) {
        if ((this.model.type === 'rec' && this.balance.current > 0) ||
            (this.model.type === 'pay' && this.balance.current < 0)) {
          item.lending_value = totalBalance / n
        }
      }
    },
  }
}

export default Mixin
